import { Dialog } from "@headlessui/react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setExpirationModal } from "../../redux/actions/authentication";
import { IKImage } from "imagekitio-react";

export default function TokenExpiredModal() {

    const setExpirationToken = useSelector(store => store?.authentication?.set_expiration_token ? store?.authentication?.set_expiration_token : false)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        if (setExpirationToken) {
            navigate('/courses')
        }
    }, [setExpirationToken])

    return (
        <div>
            <div>
                <Dialog open={setExpirationToken} onClose={() => dispatch(setExpirationModal(false))}
                    as="div"
                    style={{ zIndex: '9999999999' }}
                    className="fixed inset-0 z-10 overflow-y-auto flex md:justify-start md:mt-20 -mt-10 justify-center flex-col items-center">
                    <Dialog.Overlay className="fixed inset-0 bg-black opacity-70 z-10" />
                    <Dialog.Title />
                    <Dialog.Description />
                    <div className='bg-white z-10 md:w-2/3 lg:w-[23rem] md:h-[23rem] w-5/6 h-[23rem] rounded-2xl flex flex-col justify-between py-4 px-4 items-center md:p-4 text-center shadow-2xl'>
                        <img
                            urlEndpoint="https://assets.learntube.ai/files/"
                            src={`https://assets.learntube.ai/files/homepage-banner/sessionExpired.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1666349694983`}
                            className="w-2/4 h-2/4"
                            transformation={[{
                                "height": "260",
                                "width": "260",
                            }]}
                        />
                        <h2 className="font-bold text-xl">Your Session has Expired</h2>
                        <p>Your session has expired. Click okay to return to the login screen.</p>
                        <button className="bg-[#13A0BD] px-5 py-2 text-white rounded-3xl text-sm md:text-base" onClick={() => dispatch(setExpirationModal(false))}>Okay</button>
                    </div>
                </Dialog>
            </div>
        </div>
    )
}